import { useAppStore } from "./store";

export const selectOrganization = (organizationUuid: string) =>
  useAppStore.getState().selectOrganization(organizationUuid);

export const selectOrganizationUnit = (organizationUnitUuid: string) =>
  useAppStore.getState().selectOrganizationUnit(organizationUnitUuid);

export const refreshOrganizationUnitData = (organizationUnitUuid: string) =>
  useAppStore.getState().refreshOrganizationUnitData(organizationUnitUuid);

export const refreshOrganizationData = (organizationUuid: string) =>
  useAppStore.getState().refreshOrganizationData(organizationUuid);

